export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL

export const USER_TYPES = {
  ADMIN: 1,
  PHARMACIST: 2,
  PHARMACY_MANAGER: 3
}

export const DEFAULT_GUTTER = [
  { xs: 4, sm: 8, md: 12, xl: 16 },
  { xs: 4, sm: 8, md: 12, xl: 16 }
]
